<template>
  <div id="AppViewer">
    <DDViewer
      v-bind="{ 
        url,
        title,
        isPublic,
        canPrint,
        canDownload,
        isOpenModal,
        titleModal,
        contentModal,
        classModal,
        baseUrlRedirect,
        isSearchTerm,
        ownerRevision,
        canPrintSampleWatermark,
        canPrintWatermarkRevisionHistory,
        canDownloadWatermark,
        canPrintWatermark,
        oldRevision,
        revisionData
      }"
    ></DDViewer>
  </div>
</template>

<script>
import DDViewer from "./components/DDViewer.vue";

export default {
  name: "app",

  components: {
    DDViewer
  },

  data() {
    return {
      url: "",
      title: "",
      canPrint: false,
      canDownload: false,
      isPublic: false,
      viewerThumb: false,
      baseUrlRedirect: "",
      isOpenModal: false,
      titleModal: "",
      contentModal: "",
      classModal: "",
      isSearchTerm: "",
      ownerRevision: false,
      oldRevision: false,
      canDownloadWatermark: false,
      canPrintWatermark: false,
      canPrintSampleWatermark: false,
      canPrintWatermarkRevisionHistory: false,
      revisionData: null // <--- tudo que antes ia pro session fica aqui
    };
  },

  methods: {
    in_array(dataSearch, array) {
      return array.includes(dataSearch);
    },

    isThumb(extension, extThumb) {
      return this.in_array(extension, extThumb);
    },

    limitWords(words, limit) {
      return words.length > limit ? words.substring(0, limit) + " ..." : words;
    },

    isValidJson(str) {
      try {
        JSON.parse(str);
        return true;
      } catch {
        return false;
      }
    },

    async startDocViewer() {
      try {
        let currentURL = window.location.href;
        console.log('startDocViewer: current URL:', currentURL);

        let cURL = currentURL.includes("/#/") 
          ? currentURL.split("/#/") 
          : null;

        if (!cURL) {
          console.log('startDocViewer: no #/ in URL, returning');
          return;
        }

        let opURL = cURL[1].includes("/")
          ? cURL[1].split("/")
          : null;

        let extThumb = ["jpg", "jpeg", "png", "gif"];

        if (!opURL) {
          console.log('startDocViewer: no opURL, parsing decoded data');
          let decoded = JSON.parse(decodeURIComponent(cURL[1]));
          this.revisionData = decoded;

          this.applyRevisionData(decoded, extThumb);

          history.pushState(
            decoded,
            "Digitaldoc V4 - Viewer",
            `#/${decoded.revision.id}/${decoded.revision.extension.toLowerCase()}`
          );

          return;
        }

        //
        // Caso 2: Public viewer
        //
        if (opURL[0] === "public") {
          console.log('startDocViewer: public viewer, guid:', opURL[1]);
          this.isPublic = true;
          let guid = opURL[1];

          console.log('startDocViewer: making GET request to:', process.env.VUE_APP_QUALIDOC_DDV4_API + "/viewer/public/" + guid);
          let resp = await this.axios.get(
            process.env.VUE_APP_QUALIDOC_DDV4_API + "/viewer/public/" + guid
          );
          console.log('startDocViewer: public API response:', resp.data);

          if (!resp.data.IsPublic) {
            this.setModal(
              "Acesso negado",
              "Este arquivo não está mais público.",
              "md-error"
            );
            return;
          }

          let item = {
            revision: {
              id: resp.data.Id,
              title: resp.data.Title,
              extension: resp.data.Extension
            },
            infos: {
              canPrint: false,
              canDownload: false,
              canSearch: false,
              searchTerm: null,
              user: {},
              urlBase: ""
            }
          };

          this.revisionData = item;

          this.url = resp.data.File;
          this.title = this.limitWords(resp.data.Title, 65);
          console.log('startDocViewer: public doc set, url length:', this.url.length);

          return;
        }

        console.log('startDocViewer: parsing decoded data for non-public');

        const decodedStr = decodeURIComponent(cURL[1]);

        if (this.isValidJson(decodedStr)) {
          const decoded = JSON.parse(decodedStr);
          this.revisionData = decoded;
          this.applyRevisionData(decoded, extThumb);
          return;
        }

        console.warn('startDocViewer: URL não contém JSON válido:', decodedStr);
      } catch (error) {
        console.error('startDocViewer error:', error);
        this.setModal(
          "Erro ao carregar documento",
          "Ocorreu um erro ao buscar o documento.",
          "md-error"
        );
      }
    },

    applyRevisionData(data, extThumb) {
      console.log('applyRevisionData: data received:', data);
      this.canPrint = data.infos.canPrint;
      this.canDownload = data.infos.canDownload;
      this.ownerRevision = data.infos.user.ownerRevision;
      this.oldRevision = data.revision.isOldRevision;

      this.canPrintWatermark = data.infos.canPrintWatermark;
      this.canPrintSampleWatermark = data.infos.canPrintSampleWatermark;
      this.canPrintWatermarkRevisionHistory =
        data.infos.canPrintWatermarkRevisionHistory;
      this.canDownloadWatermark = data.infos.canDownloadWatermark;

      if (this.isThumb(data.revision.extension.toLowerCase(), extThumb))
        this.viewerThumb = true;

      if (data.infos.canSearch)
        this.isSearchTerm = data.infos.searchTerm;
      console.log('applyRevisionData: permissions set, canPrint:', this.canPrint, 'canDownload:', this.canDownload);
    },

    async getDoc() {
      try {
        if (this.revisionData !== null) {
          if (this.revisionData.revision.id == undefined) {
            return;
          }
        }

        if (this.revisionData === null) {
          this.setModal(
            "Erro ao carregar documento",
            "Não foi possível carregar o documento.",
            "md-error"
          );

          return;
        }

        let rev = this.revisionData;
        console.log('getDoc: revisionData:', rev);

        console.log('getDoc: making POST request to:', process.env.VUE_APP_QUALIDOC_DDV4_API + "/viewer/", 'with data:', { 
          ...rev.revision,
          server: "CVALE",
          setor: " ",
          user: rev.infos.user.name
        });
        let response = await this.axios.post(
          process.env.VUE_APP_QUALIDOC_DDV4_API + "/viewer/",
          { 
            ...rev.revision,
            server: "CVALE",
            setor: " ",
            user: rev.infos.user.name
          }
        );
        console.log('getDoc: API response received, url length:', response.data.length);

        this.url = response.data;
        this.title = this.limitWords(rev.revision.title, 65);
        console.log('getDoc: url set, title:', this.title);
      } catch (error) {
        console.error('getDoc error:', error);
        this.setModal(
          "Erro ao carregar documento",
          "Não foi possível carregar o documento.",
          "md-error"
        );
      }
    },

    setModal(t, c, mClass) {
      this.isOpenModal = true;
      this.titleModal = t;
      this.contentModal = c;
      this.classModal = mClass;
    }
  },

  async mounted() {
    await this.startDocViewer();
    await this.getDoc();

    window.addEventListener('hashchange', async () => {
      console.log('hashchange detected, reloading doc...');
      this.url = "";
      this.revisionData = null;
      this.isPublic = false;
      this.isOpenModal = false;

      await this.startDocViewer();
      await this.getDoc();
    });
  },
};
</script>

<style>
@media print {
  body {
    background-color: transparent;
  }
}
</style>